import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { changeStatus, onSetSelectedReference, selectReferenceState, setAction } from "../redux/slices/referenceDocumentSlice"
import { ReferenceDocumentsAPI } from "../apis/ReferenceDocumentsAPI"
import { referenceDocument } from "../types/slices/referenceDocumentType"

export const useReferenceDocumentStore = () => {

    const dispatch = useDispatch()
    const { references, referenceSelected, status, action } = useSelector(selectReferenceState)

    const getReferenceDocuments = async (data:{}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ReferenceDocumentsAPI.getReferenceDocuments(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createReferenceDocument = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ReferenceDocumentsAPI.createReferenceDocument(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editReferenceDocument = async (idproduct: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ReferenceDocumentsAPI.editReferenceDocument(idproduct, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteReferenceDocument = async (idproduct: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ReferenceDocumentsAPI.deleteReferenceDocument(idproduct)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedReferenceDocument = (reference: referenceDocument) => {
        try {
            dispatch(onSetSelectedReference(reference))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionReference = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        references,
        referenceSelected,
        status,
        action,
        //actions
        getReferenceDocuments,
        createReferenceDocument,
        editReferenceDocument,
        deleteReferenceDocument,
        setSelectedReferenceDocument,
        setActionReference,
    }
}